import { Pipe, PipeTransform } from '@angular/core';
import { UserUtilsService } from '../services/user/user-utils.service';

@Pipe({
  name: 'buildNotificationTemplate'
})
export class BuildNotificationTemplatePipe implements PipeTransform {

  constructor( private utilsService: UserUtilsService ) {}

  transform(type: string, translations: any, content: any): any {
    const contractSelected = this.utilsService.getUserContractInfoSessionStorage()
    switch(type) {
      case 'MSJ_BDVA':
        return `${translations.RETURN_OLD_BANK.p1} <strong>${translations.RETURN_OLD_BANK.p2}</strong> ${translations.RETURN_OLD_BANK.p3} <strong>${translations.RETURN_OLD_BANK.p4}</strong>.`;
      case 'BBD_NBD':
        return `${translations.NEW_USER_WELCOME.p1} <strong>${translations.NEW_USER_WELCOME.p2}</strong> ${translations.NEW_USER_WELCOME.p3} <a class="new-bank">${translations.NEW_USER_WELCOME.p4}</a>. <strong>${translations.NEW_USER_WELCOME.p5}</strong>`;
      case 'CMP_CARGA':
        return `${translations.PAYMENTS.p1} ${contractSelected.refNumContrato} ${translations.PAYMENTS.p2} <strong>${translations.PAYMENTS.p3} ${content.idProceso}</strong>`;
      case 'CMP_AUTO':
        return `${translations.PAYMENTS.p1} ${contractSelected.refNumContrato} ${translations.PAYMENTS.p2} <strong>${translations.PAYMENTS.p3} ${content.processId}</strong>`;
      case 'CMD_CARGA':
        return `${translations.CARGA.p1} ${contractSelected.refNumContrato} ${translations.CARGA.p2} <strong>${translations.CARGA.p3} ${content.idProceso}</strong>`;
      case 'CMD_AUTO':
        return `${translations.AUTO.p1} ${contractSelected.refNumContrato} ${translations.AUTO.p2} <strong>${translations.AUTO.p3} ${content.processId}</strong> ${translations.AUTO.p4}`;
      default:
        ``;
        break;
    }
  }

}
